export { default as Profiles } from './components/profiles';
export { default as ProfileTile } from './components/profile-tile';



// WEBPACK FOOTER //
// ./src/components/profiles/index.js